import { render } from "./LoginPopup.vue?vue&type=template&id=1860e662&scoped=true"
import script from "./LoginPopup.vue?vue&type=script&lang=js"
export * from "./LoginPopup.vue?vue&type=script&lang=js"

import "./LoginPopup.vue?vue&type=style&index=0&id=1860e662&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1860e662"]])

export default __exports__